import { useTranslation } from "react-i18next"
import { Button } from "@/components/ui/button"
import { FaroInsightsWrapper } from "@/grafana-faro"
import { useIsTelematikInfrastructureSigningEnabled } from "@/modules/patients/detail/conclude/services/de/useIsTelematikInfrastructureSigningEnabled"

interface TelematikInfrastructureSignButtonProps {
  isDisabled: boolean
  isLoading: boolean
  onSign: () => void
}

// Rendered only for users with a Telematik-ID: the query behind the switch exists in the German schema alone
const TelematikInfrastructureSignButton = ({
  isDisabled,
  isLoading,
  onSign,
}: TelematikInfrastructureSignButtonProps) => {
  const { t } = useTranslation()
  const isSigningEnabled = useIsTelematikInfrastructureSigningEnabled()

  if (!isSigningEnabled) {
    return null
  }

  return (
    <Button
      data-testid="sign-with-telematik-infrastructure-button"
      disabled={isDisabled}
      className="mr-2 min-w-19.5 px-6"
      isLoading={isLoading}
      onClick={() => {
        FaroInsightsWrapper.pushEvent("check_out_sign_telematik_infrastructure")
        onSign()
      }}>
      {t("patient.conclude.signWithTelematikInfrastructure")}
    </Button>
  )
}

export { TelematikInfrastructureSignButton }
